import React from 'react';

const ClassFilter = ({ classes, selectedClass, onSelectClass }) => {
  return (
    <div className="class-filter">
      <div className="filter-label">Filter by Class:</div>
      <div className="filter-buttons">
        <button
          className={`filter-btn ${!selectedClass ? 'active' : ''}`}
          onClick={() => onSelectClass(null)}
        >
          All Classes
        </button>
        {classes.map((year) => (
          <button
            key={year}
            className={`filter-btn ${selectedClass === year ? 'active' : ''}`}
            onClick={() => onSelectClass(year)}
          >
            Class of {year}
          </button>
        ))}
      </div>

      <style>{`
        .class-filter {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-wrap: wrap;
          gap: 10px;
          padding: 16px 0;
        }
        .filter-label {
          color: #8888aa;
          font-size: 0.85rem;
          font-weight: 600;
          margin-right: 4px;
        }
        .filter-buttons {
          display: flex;
          gap: 8px;
          flex-wrap: wrap;
          justify-content: center;
        }
        .filter-btn {
          padding: 8px 20px;
          border-radius: 20px;
          border: 2px solid #2a2a4a;
          background: transparent;
          color: #aaaacc;
          font-size: 0.85rem;
          cursor: pointer;
          font-weight: 600;
          transition: all 0.2s;
        }
        .filter-btn:hover {
          border-color: #f7971e;
          color: #f7971e;
        }
        .filter-btn.active {
          background: #f7971e;
          border-color: #f7971e;
          color: #1a1a2e;
        }
      `}</style>
    </div>
  );
};

export default ClassFilter;
